import {CardMedia, Grid, Paper, Typography, Box, Link} from '@material-ui/core'
import React from "react"
import './Article.css'
import { useNavigate } from 'react-router'

const Articles = props => {
    let navigate = useNavigate()
    return (
        <div>
            <Grid container spacing={4}>
                <Grid item xs={1} >
                    <Paper elevation={0} style={{ height: '75px' }} square></Paper>
                </Grid>
                <Grid item xs={1}>
                    <Paper elevation={0} style={{ height: '75px' }} square></Paper>
                </Grid>
                <Grid item xs={1}/>
                <Grid item xs={5}>
                    <Paper elevation={0} style={{ height: '75px' }} square></Paper>
                </Grid>
                <Grid item xs={2}/>
            </Grid>
            <Link to='cluster' onClick={() => navigate('cluster')}>
                <Box sx={{ p: 2}}>
                    <Grid container spacing={0} alignItems='center'>
                        <Grid item xs={1}/>
                        <Grid item xs={12} md={6}>
                            <Paper elevation={4} style={{ backgroundColor:'#fafafa', padding: '15px'}} square>
                                <Typography variant="overline" className='articles-about' sx={{ color: 'gray', fontWeight: 600 }}>data science</Typography>
                                <Typography variant="h5" sx={{ color: 'gray', fontWeight: 600 }}>Building an ML Model to Find Socioeconomic Clusters</Typography>
                                <Typography variant="body1" sx={{ color: 'gray', mt: 2 }} className='third-line'>
                                    What happens when we use the Python K-Cluster library to partition New York City Metro into distinct neighborhood groupings?
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={0} md={2}>
                            <Paper elevation={4} square>
                                <CardMedia
                                    component='img'
                                    height='171'
                                    image='./images/articles/k-nearest/nyc-zoom.png'
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={1}>
                            <Paper elevation={4} square></Paper>
                        </Grid>
                        <Grid item xs={1}/>
                        <Grid item xs={3}>
                            <Paper square></Paper>
                        </Grid>
                    </Grid>
                </Box>
            </Link>
            {/*<Grid container spacing={2}>*/}
            {/*    <Grid item xs={1}>*/}
            {/*        <Paper elevation={0} style={{ height: '75px' }} square></Paper>*/}
            {/*    </Grid>*/}
            {/*    <Grid item xs={1}>*/}
            {/*        <Paper elevation={0} style={{ height: '75px' }} square></Paper>*/}
            {/*    </Grid>*/}
            {/*    <Grid item xs={1}/>*/}
            {/*    <Grid item xs={5}>*/}
            {/*        <Paper elevation={0} style={{ height: '75px' }} square></Paper>*/}
            {/*    </Grid>*/}
            {/*    <Grid item xs={2}/>*/}
            {/*</Grid>*/}
            <Link to='cluster' onClick={() => navigate('gyms')}>
                <Box sx={{ p: 2}}>
                    <Grid container spacing={0} alignItems='center'>
                        <Grid item xs={1}/>
                        <Grid item xs={12} md={6}>
                            <Paper elevation={4} style={{ backgroundColor:'#fafafa', padding: '15px'}} square>
                                <Typography variant="overline" className='articles-about' sx={{ color: 'gray', fontWeight: 600 }}>data science</Typography>
                                <Typography variant="h5" sx={{ color: 'gray', fontWeight: 600 }}>Equinox vs. LA (and Planet) Fitness Census Tracts</Typography>
                                <Typography variant="body1" sx={{ color: 'gray', mt: 2 }} className='third-line'>
                                    How different gym brands and the markets they serve inform our understanding of the classifications of unsupervised machine learning models
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={0} md={2}>
                            <Paper elevation={4} square>
                                <CardMedia
                                    component='img'
                                    height='171'
                                    image='./images/articles/gyms/nyc_census.png'
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={1}>
                            <Paper elevation={4} square></Paper>
                        </Grid>
                        <Grid item xs={1}/>
                        <Grid item xs={3}>
                            <Paper square></Paper>
                        </Grid>
                    </Grid>
                </Box>
            </Link>
        </div>

    )
}


export default Articles
